import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class AdminToolsService {
  private readonly managirUrl: string = environment.managirUrl.replace(
    "/api/v1",
    ""
  );

  constructor(private http: HttpClient) {}

  public async sendActivationReminderEmails() {
    const url = this.managirUrl + "/activation/sendreminder";
    const body = {};
    const options = { headers: { "Content-Type": "application/json" } };
    return await this.http.post(url, body, options).toPromise();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/admin-tools/admin-tools.service.ts